export default __webpack_public_path__ + "static/news26-25dee10c0a069cfbdff1d6eeb3ec508f.png";